function TrainNumbersFormController(stateService, toasterService, $uibModal) {
  const ctrl = this;

  ctrl.$onInit = async () => {
    // Init train number object
    ctrl.trainNumber = {
      variables: [],
      add_variable: [],
      runs: []
    };
    // Set viewmode if selection object is present
    if (!ctrl.selection) {
      ctrl.newTrainNumber = true;
      ctrl.viewMode = false;
    } else {
      ctrl.trainNumber = angular.copy(ctrl.selection);
      ctrl.viewMode = true;
    }
    ctrl.workspaceId = stateService.getSelectedWorkspace().id;
    stateService.getRunsAndRoutes(ctrl.workspaceId).then(data => {

      ctrl.runs = data.runs;

      let defaultRun = ctrl.runs.find(({ id }) => id === ctrl.trainNumber.run);
      // use the first one if no default run
      if (ctrl.runs) {
        if (!defaultRun) {
          ctrl.selectedRun = ctrl.runs[0];
        } else {
          ctrl.selectedRun = defaultRun;
        }
      }
      ctrl.runsOfSelectedTrain = [];
      for (const run of ctrl.trainNumber.runs) {
        ctrl.runsOfSelectedTrain.push(ctrl.runs.find(({ id }) => id === run));
      }
    });
  };

  ctrl.toggleEditMode = value => {
    if (value) {
      ctrl.viewMode = false;
    } else {
      ctrl.trainNumber = angular.copy(ctrl.selection);
      ctrl.viewMode = true;
    }
  };

  ctrl.checkValidity = () => {
    return (
      ctrl.trainNumber.run === undefined || ctrl.trainNumber.number === undefined
    );
  };

  ctrl.clearForm = () => {
    ctrl.trainNumber = {
      number: undefined,
      variables: [],
      add_variable: [],
      run: undefined,
      runs: []
    };
    ctrl.selectedRun = null;
    ctrl.runsOfSelectedTrain = [];
  };

  ctrl.openVariableModal = () => {
    let modalInstance = $uibModal.open({
      component: 'variableModal',
      backdrop: 'static',
      windowClass: 'subSystemWindow',
      resolve: {
        workspaceId: () => ctrl.workspaceId,
        view: () => 'train number'
      },
    });

    modalInstance.result.then(
      variableObject => {
        // User pressed 'Yes' in the modal.
        ctrl.trainNumber.variables.push(variableObject);
      },
      () => {
        // User pressed 'Cancel' in the modal, do nothing.
      }
    );
  };

  ctrl.openRunModal = () => {
    let availableRuns = [];
    _.each(ctrl.runs, run => {
        if (!ctrl.runsOfSelectedTrain.includes(run)) {
          availableRuns.push(run);
        }
    });
    let modalInstance = $uibModal.open({
      component: 'listModal',
      backdrop: 'static',
      windowClass: 'subSystemWindow',
      resolve: {
        items: () => availableRuns,
        type: () => 'run',
      },
    });

    modalInstance.result.then(
      selectedRun => {
        // User pressed 'Add run' in the modal.
        ctrl.selectedRun = selectedRun;
        ctrl.trainNumber.run = selectedRun.id;
        ctrl.trainNumber.runs.push(selectedRun.id);
        ctrl.runsOfSelectedTrain.push(ctrl.runs.find(run => run.id === selectedRun.id));
      },
      () => {
        // User pressed 'Cancel' in the modal, do nothing.
      }
    );
  };

  ctrl.removeRun = (removedRunId) => {
    if (typeof removedRunId !== "undefined") {
      let remainingRuns = ctrl.runsOfSelectedTrain.filter(run => run.id !== removedRunId);
      ctrl.runsOfSelectedTrain = remainingRuns;
      ctrl.trainNumber.runs = remainingRuns.map(({id}) => id);
    } else {
      ctrl.trainNumber.run = undefined;
      ctrl.selectedRun = null;  
    }
  };

  ctrl.setDefaultRun = (runId) => {
    ctrl.selectedRun = ctrl.runs.find(run => run.id === runId);
    ctrl.trainNumber.run = ctrl.selectedRun.id;
  };

  ctrl.removeVariable = index => {
    ctrl.trainNumber.variables.splice(index, 1);
  };

  ctrl.onSubmit = () => {
    // NEW PTI CODE
    if (ctrl.newTrainNumber) {
      stateService.createTrainNumber(ctrl.trainNumber, ctrl.workspaceId).then(
        function(response) {
          ctrl.onFormSubmit({
            $event: {
              mode: false,
            },
          });
          toasterService.success('toaster.pis-event', 'toaster.pis-new-train-number-successful');
        },
        function(e) {
          toasterService.error('toaster.pis-event', 'toaster.pis-new-train-number-failure');
          console.error(e);
        }
      );
    } else {
      // EDIT PTI CODE
      ctrl.trainNumber.add_variable = [];
      stateService.editTrainNumber(ctrl.workspaceId, ctrl.trainNumber.id, ctrl.trainNumber).then(
        function(response) {
          ctrl.onFormSubmit({
            $event: {
              mode: false,
            },
          });
          toasterService.success('toaster.pis-event', 'toaster.pis-edit-train-number-successful');
        },
        function(e) {
          toasterService.error('toaster.pis-event', 'toaster.pis-edit-train-number-failure');
          console.error(e);
        }
      );
    }
  };
}

angular
  .module('pis-tool.module')
  .controller('TrainNumbersFormController', TrainNumbersFormController);
